<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/ui/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div data-slot="skeleton" :class="cn('bg-stone-200 animate-pulse rounded-md', props.class)">
    <slot />
  </div>
</template>
